import { get } from 'lodash-es';

export const taskDetailSuccessMsgSelector = (state) => get(state, ['taskDetail', 'successMsg']);
export const taskDetailErrorMsgSelector = (state) => get(state, ['taskDetail', 'errorMsg']);
export const taskDetailResTitleSelector = (state) => get(state, ['taskDetail', 'resTitle']);
export const taskDetailResFooterSelector = (state) => get(state, ['taskDetail', 'resFooter']);
export const currentTaskSelector = (state) => get(state, ['taskDetail', 'currentTask']);
export const tpInfoVisibleSelector = (state) => get(state, ['taskDetail', 'tpInfoVisible']);
export const substagesVisibleSelector = (state) => get(state, ['taskDetail', 'substagesVisible']);
export const opsInfoVisibleSelector = (state) => get(state, ['taskDetail', 'opsInfoVisible']);
export const modalTypeSelector = (state) => get(state, ['taskDetail', 'modalType']);
